import { types } from "../types/types";
import { collectPreNewEditFields, groupPreNewEditFields } from "../helpers/moduleConfigPreNewEditHelper";

const initialState = {
  
  listFields: [],
  listFieldsTechnology: [],
  listFieldsTechnologyView: [],
  listFieldsAlternativeTech: [],

  listFieldsConceptualVision: [],

  listFieldsTechnologyPreview: {},
  listFieldsTechnologyPre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },

  listFieldsAlternative: [],
  listFieldsAlternativeView: [],
  listFieldsAlternativePreview: [],
  listFieldsAlternativeNew: [],
  listFieldsAlternativePre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },

  listFieldsExperience: [],
  listFieldsExperienceView: [],
  listFieldsExperiencePreview: [],
  listFieldsExperienceNew: [],
  listFieldsExperiencePre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },

  listFieldsInnovation: [],
  listFieldsInnovationView: [],
  listFieldsInnovationPreview: [],
  listFieldsInnovationNew: [],
  listFieldsInnovationPre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },

  listFieldsAssistance: [],
  listFieldsAssistanceView: [],
  listFieldsAssistancePreview: [],
  listFieldsAssistanceNew: [],
  listFieldsAssistancePre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },

  listFieldsFinancial: [],
  listFieldsFinancialView: [],
  listFieldsFinancialPreview: [],
  listFieldsFinancialNew: [],
  listFieldsFinancialPre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },

  listFieldsVision: [],
  listFieldsVisionView: [],
  listFieldsVisionPreview: [],
  listFieldsVisionNew: [],
  listFieldsVisionPre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },

  listFieldsRegulation: [],
  listFieldsRegulationView: [],
  listFieldsRegulationPreview: [],
  listFieldsRegulationNew: [],
  listFieldsRegulationPre: {
    arrayListPrincipal: [],
    arrayListSecondary: [],
    arrayListPrincipalEnabled: false,
    arrayListSecondaryEnabled: false
  },
};

export const moduleConfigReducer = (state = initialState, action) => {

  switch (action.type) {

    case types.MODULE_CONFIG_START_LOADING_BY_ROLE_PROCESS:

      return {
        ...state,
        listFields: action.payload,
        listFieldsTechnology: action.payload.filter((field) => field.module_text === "technology"),
        listFieldsTechnologyView: orderByPriorityView(action.payload.filter((field) => field.module_text === "technology")),
        listFieldsTechnologyPreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "technology")),
        listFieldsTechnologyNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "technology")),
        listFieldsTechnologyPre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "technology"))),

        listFieldsAlternative: action.payload.filter((field) => field.module_text === "alternative"),
        listFieldsAlternativeView: orderByPriorityView(action.payload.filter((field) => field.module_text === "alternative")),
        listFieldsAlternativePreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "alternative")),
        listFieldsAlternativeNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "alternative")),
        listFieldsAlternativePre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "alternative"))),

        listFieldsExperience: action.payload.filter((field) => field.module_text === "experience"),
        listFieldsExperienceView: orderByPriorityView(action.payload.filter((field) => field.module_text === "experience")),
        listFieldsExperiencePreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "experience")),
        listFieldsExperienceNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "experience")),
        listFieldsExperiencePre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "experience"))),

        listFieldsInnovation: action.payload.filter((field) => field.module_text === "innovation"),
        listFieldsInnovationView: orderByPriorityView(action.payload.filter((field) => field.module_text === "innovation")),
        listFieldsInnovationPreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "innovation")),
        listFieldsInnovationNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "innovation")),
        listFieldsInnovationPre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "innovation"))),

        listFieldsAssistance: action.payload.filter((field) => field.module_text === "assistance"),
        listFieldsAssistanceView: orderByPriorityView(action.payload.filter((field) => field.module_text === "assistance")),
        listFieldsAssistancePreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "assistance")),
        listFieldsAssistanceNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "assistance")),
        listFieldsAssistancePre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "assistance"))),

        listFieldsFinancial: action.payload.filter((field) => field.module_text === "financial"),
        listFieldsFinancialView: orderByPriorityView(action.payload.filter((field) => field.module_text === "financial")),
        listFieldsFinancialPreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "financial")),
        listFieldsFinancialNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "financial")),
        listFieldsFinancialPre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "financial"))),

        listFieldsVision: action.payload.filter((field) => field.module_text === "vision"),
        listFieldsVisionView: orderByPriorityView(action.payload.filter((field) => field.module_text === "vision")),
        listFieldsVisionPreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "vision")),
        listFieldsVisionNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "vision")),
        listFieldsVisionPre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "vision"))),

        listFieldsRegulation: action.payload.filter((field) => field.module_text === "regulation"),
        listFieldsRegulationView: orderByPriorityView(action.payload.filter((field) => field.module_text === "regulation")),
        listFieldsRegulationPreview: orderByPriorityViewR(action.payload.filter((field) => field.module_text === "regulation")),
        listFieldsRegulationNew: orderByPriorityNewR(action.payload.filter((field) => field.module_text === "regulation")),
        listFieldsRegulationPre: groupPreNewEditFields(collectPreNewEditFields(action.payload.filter((field) => field.module_text === "regulation"))),

      };

    case types.MODULE_CONFIGURATION_SELECT:
      return {
        ...state,
        moduleConfiguration: action.payload,
      };

    case types.MODULE_CONFIGURATION_UPDATE:
      if (state.moduleConfigurationsS.length > 0) {
        return {
          ...state,
          moduleConfigurationsS: state.moduleConfigurationsS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          moduleConfigurationsP: state.moduleConfigurationsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          moduleConfigurationsP: state.moduleConfigurationsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.MODULE_CONFIGURATION_DELETE:
      if (state.moduleConfigurationsS.length > 0) {
        return {
          ...state,
          moduleConfigurationsS: state.moduleConfigurationsS.filter((usr) => usr.id !== action.payload),
          moduleConfigurationsP: state.moduleConfigurationsP.filter((usr) => usr.id !== action.payload),
          moduleConfiguration: {},
        };
      } else {
        return {
          ...state,
          moduleConfigurationsP: state.moduleConfigurationsP.filter((usr) => usr.id !== action.payload),
          moduleConfiguration: {},
        };
      }

    case types.MODULE_CONFIGURATION_START_LOADING:
      return {
        ...state,
        moduleConfigurations: action.payload,
      };

    case types.MODULE_CONFIGURATION_START_LOADING_PAGINATED:
      return {
        ...state,
        
        moduleConfigurationsP: action.payload.moduleConfigsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.MODULE_CONFIGURATION_START_SEARCH:
      return {
        ...state,
        moduleConfigurationsS: action.payload,
      };

    case types.MODULE_CONFIGURATION_START_SEARCH_PAGINATED:
      return {
        ...state,
        
        moduleConfigurationsS: action.payload.moduleConfigsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.MODULE_CONFIGURATION_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        moduleConfigurationsS: [],
      };

    case types.MODULE_CONFIGURATION_CLEAN:
      return {
        ...state,
        moduleConfiguration: {},
      };

    case types.MODULE_CONFIGURATION_START_REGISTER:
      return {
        ...state,
        moduleConfiguration: action.payload,
      };

    case types.MODULE_CONFIGURATION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};

const orderByPriorityView = (arrayList) => {
  arrayList.sort((a, b) => a.order_view - b.order_view);
  
  return arrayList;
}

const orderBySectionFieldOrder = (arrayList) => {
  arrayList.sort((a, b) => a.view_section_field_order - b.view_section_field_order);
  
  return arrayList;
}

const orderBySectionFieldOrderNew = (arrayList) => {
  arrayList.sort((a, b) => a.new_section_field_order - b.new_section_field_order);
  
  return arrayList;
}

const orderByPriorityViewR = (arrayList) => {

  let arrayListPrincipal = []; 
  let arrayListSecondary = []; 

  arrayList.forEach(element => {

    if (element.view_section_order === 1) {
      arrayListPrincipal.push(element);
    } else if (element.view_section_order === 2) {
      arrayListSecondary.push(element);
    }

  });

  arrayListPrincipal = orderBySectionFieldOrder(arrayListPrincipal);
  arrayListSecondary = orderBySectionFieldOrder(arrayListSecondary);

  const arrayListPrincipalEnabled = arrayListPrincipal.some(element => element.show_view_preview);
  const arrayListSecondaryEnabled = arrayListSecondary.some(element => element.show_view_preview);

  return {
    arrayListPrincipal, arrayListSecondary,
    arrayListPrincipalEnabled, arrayListSecondaryEnabled
  }
}

const orderByPriorityNewR = (arrayList) => {

  let arrayListPrincipal = []; 
  let arrayListSecondary = []; 

  arrayList.forEach(element => {

    if (element.new_section_order === 1) {
      arrayListPrincipal.push(element);
    } else if (element.new_section_order === 2) {
      arrayListSecondary.push(element);
    }

  });

  arrayListPrincipal = orderBySectionFieldOrderNew(arrayListPrincipal);
  arrayListSecondary = orderBySectionFieldOrderNew(arrayListSecondary);

  const arrayListPrincipalEnabled = arrayListPrincipal.some(element => element.show_new);
  const arrayListSecondaryEnabled = arrayListSecondary.some(element => element.show_new);

  return {
    arrayListPrincipal, arrayListSecondary,
    arrayListPrincipalEnabled, arrayListSecondaryEnabled
  }
}

